import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'tf-core-fb-basic-input-checklist-label-type',
  templateUrl: './fb-basic-input-checklist-label-type.component.html',
  styleUrls: ['./fb-basic-input-checklist-label-type.component.css']
})
export class FbCoreBasicInputChecklistLabelTypeComponent implements OnInit {
    @Input()
    data: any;

    constructor() { }

    ngOnInit(): void {
        if (this.data === undefined) {
            this.data = {
                type: 'label',
                content: ''
            };
        }
    }
}
